var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongBiaoqianXian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14h-.5a.5.5 0 00.757.429L3 14zm10 0l-.257.429A.5.5 0 0013.5 14H13zm-5-3l.257-.429L8 10.417l-.257.154L8 11zm-4.5 3V2.5h-1V14h1zm0-11.5h9v-1h-9v1zm9 0V14h1V2.5h-1zm.757 11.071l-5-3-.514.858 5 3 .514-.858zm-5.514-3l-5 3 .514.858 5-3-.514-.858zM12.5 2.5h1a1 1 0 00-1-1v1zm-9 0v-1a1 1 0 00-1 1h1z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_biaoqian_xian.b1a2ee55.svg";
export { SvgTongyongBiaoqianXian as ReactComponent };